var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reserva-ok"},[(_vm.loading)?_c('p',[_vm._v(_vm._s(_vm.translate('reservaCompletando')))]):(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_c('p',[_vm._v(_vm._s(_vm.translate('reservaListo')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab4d526","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ReservaOk.vue
// module id = j7OJ
// module chunks = 1